import { RouterProvider } from "react-router-dom";
import router from "./pages";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setColorAll } from "./store/modules/colorplate";
import { setLanguageS } from "./store/modules/language";

function App() {
  const {bg}=useSelector((state)=>state.colorplate);
  const dispatch=useDispatch();
  const hasFetched = useRef(false);

  useEffect(() => {
    if(hasFetched.current) return;
    let language = localStorage.getItem('language');
    if(!language){
      const userLanguage = navigator.language;
      let lg=userLanguage.slice(0,2);
      if(userLanguage==='zh-TW'||userLanguage==='zh-HK'){
        lg='ft';
      };
      language=lg
    };
    if(language!=='zh'&&language!=='ft'&&language!=='en'&&language!=='ja')language='en'
    localStorage.setItem('language',language);
    dispatch(setLanguageS(language));

    const color = JSON.parse(localStorage.getItem('color'));
    if(!color) return;
    dispatch(setColorAll(color))
    hasFetched.current = true
  }, []);

  useEffect(() => {
    document.body.style.backgroundColor = bg;
  }, [bg]);

  return (
    <div style={{minWidth:'305px'}}>
      <RouterProvider router={router}/>
    </div>
  );
}

export default App;
